__webpack_require__.p = "/mi-assets/mi-static/mi-offers-renderer/phx-rel-r25.11.2-9nov2025117pmist/_next/";